import { useSnackbar } from "notistack";
import OrderStatus from "./OrderStatus";

export const OrderContent = ({ element, booking }) => {
  if (element?.render) return element?.render();

  switch (element.type) {
    case "title":
      return <Title value={element.value} />;
    case "copy":
      return <Copy value={element.value} render={element?.renderValue} />;
    case "tag":
      return <Tag element={element} />;
    case "time":
      return <Time value={element?.value} />;
    case "status":
      return <OrderStatus value={element?.value} />;
    case "hotelLink":
      return <HotelLink value={element?.value} booking={booking} />;
    default:
      return <Text value={element.value} />;
  }
};

const Text = ({ value }) => {
  return (
    <span className="text-sm mb-2">
      {typeof value === "string" ? value?.slice(0, 100) : ""}
      {value?.length > 100 ? "..." : ""}
    </span>
  );
};

export const Title = ({ value }) => {
  return <span className="text-sm text-[#6D7C94] mb-2">{value}</span>;
};

export const Copy = ({ value, render }) => {
  const { enqueueSnackbar } = useSnackbar();
  const handleCopy = () => {
    try {
      navigator.clipboard.writeText(value);
      enqueueSnackbar("Copied to clipboard!", { variant: "success" });
    } catch (error) {
      enqueueSnackbar("Failed to copy to clipboard!", { variant: "error" });
    }
  };
  return (
    <div
      className="flex gap-1 items-center mb-2 cursor-pointer"
      onClick={handleCopy}
    >
      <span className="text-xs text-primary1">{render ? render() : value}</span>
      <img src="/IconCopy.svg" alt="" />
    </div>
  );
};

export const Tag = ({ element }) => {
  return (
    <div className={`rounded-md `}>
      <span
        className={`${element?.color} ${element?.background} text-xs font-bold px-2 py-1 rounded-md ${element?.className}`}
      >
        {element?.value}
      </span>
    </div>
  );
};

export const Time = ({ value }) => {
  return (
    <div className="flex gap-1 items-center mb-2 cursor-pointer">
      <img src="/IconClock1.svg" alt="" />
      <span className="text-xs">{value}</span>
    </div>
  );
};

export const HotelLink = ({ value, booking }) => {
  const url = () => {
    return `/accommodation/confirmation`;
  };

  return (
    <a
      className="text-sm mb-2 text-primary1"
      href={url()}
      target="_blank"
      rel="noreferrer"
    >
      {value}
    </a>
  );
};

export const allStatuses = [
  "Not Paid",
  "Pending",
  "Paid",
  "Failed",
  "Booked",
  "Ticket issued",
  "Issued",
  "PendingTicketIssue",
  "AwaitingAdmin",
  "Expired",
  "AutoCanceled",
  "Cancelled",
  "CustomerPaid",
  "TicketCanceled",
  "Refunded",
  "TicketCancelationRequested",
];
